/// <reference path="../../../../../shared/utils/Url.ts"/>
/// <reference path="../../../../../shared/utils/View.ts"/>
/// <reference path="../../../../../shared/utils/Ajax.ts"/>
import { AppUtils } from '../../../../../shared/utils/index';
import { MglViewService } from '../../../../../shared/services/MglViewService';
import { AppApplicationService } from './AppApplicationService';
import { AppFormModel } from '../models/AppFormModel';
import { PersonalDataModel } from '../../../../../shared/models/view/PersonalData';
import { PartnerViewModel } from '../../../../../shared/models/view/Partner';
import { ChildModel } from '../../../../../shared/models/view/Child';
import { WerbeZustimmungModel } from '../../../../../shared/models/view/WerbeZustimmung';
import { ContractInfoApi } from '../../../../../shared/models/generated/PersonContractInfoApi';
import { BehindertenausweisModel } from '../../../../../shared/models/api/Behindertenausweis';
import { AppModelAdapter } from '../helper/AppModelAdapter';
import { ContractInfo } from '../../../../../shared/models/api/User/ContractInfo';
import { AdvertisingConsentModel } from '../../../../../shared/models/view/AdvertisingConsent';
import { BasicApplicationUrlBuilder } from '../../../../../shared/services/BasicApplicationUrlBuilder';

export class AppViewService extends MglViewService<MglModularSystemV2AppDefinition> {

	private readonly autocompletePendingFlag = 'autocomplete-pending';
	private readonly dateofbirthSelector: string;
	private readonly appApplicationService: AppApplicationService;
	protected readonly urlBuilder: BasicApplicationUrlBuilder<MglModularSystemV2AppDefinition>;

	private readonly rateDependSelector = '.js-rate-depend';
	private readonly backlinkSelector = '.js-back-link, .js-back-link-family';
	private readonly startOfMembershiFieldSelector = 'input[name="MitgliedschaftStartDatum"]';
	private readonly isDisability = "#isdisability";
	private readonly isEducation = "#iseducation";
	private readonly discountSelector = ".js-discount";
	private readonly submitBtnSelector = ".js-submit-form";
	private readonly birthdayChildSelector = ".js-child-birthday";
	private readonly legalNotesSelector = 'form *[data-section="legalnotice"]';
	private readonly salesmanNoSelector = '#salesmanNo';
	private readonly bonuscodeSelector = ".js-bonuscode";
	private readonly einwilligungSelector = ".js-einwilligung";
	private readonly emailPhoneAndPersonalizationSelector = '.js-email, .js-phone, .js-personalization';
	private readonly adacpaySelector = ".js-adac-pay";
	private readonly qrcodeSelector = ".js-qrcode";
	private readonly cooperationSelector = ".js-cooperation";
	private readonly officeAdvertisingKey = "#officeadvertisingkey";
	private readonly digitalClubcardSelectior = 'form *[data-section="digitalClubcard"]';
	private readonly surnameSelector = "{nachname}";
	private readonly titleSelector = "{titel}";
	private readonly nameSelector = "{vorname}";

	constructor(options: MglModularSystemV2AppOptions, loader: Loader) {
		super(options, loader);
		this.appApplicationService = new AppApplicationService(options);
		this.urlBuilder = new BasicApplicationUrlBuilder(options);

		this.dateofbirthSelector = 'input[data-validation="Geburtsdatum"]';
	}

	public updateWerbeZustimmungModel(formModel: AppFormModel): void {
		const elements = this.options.$ctx.find(this.legalNotesSelector);
		const formData = AppUtils.Url.getParamsAsCSV(elements.serialize());
		const werbeZustimmungModel = new WerbeZustimmungModel();

		formModel.WerbeZustimmungModel = werbeZustimmungModel;

		if (formData["DatenverwendungEmailZustimmung"] && formData["Email"]) {
			formModel.Antragssteller.Email = formData["Email"];
		}
		if (formData["DatenverwendungTelefonZustimmung"] && formData["TelefonVorwahl"] && formData["TelefonNummer"]) {
			formModel.Antragssteller.TelefonVorwahl = formData["TelefonVorwahl"];
			formModel.Antragssteller.TelefonNummer = formData["TelefonNummer"];
		}
		if (formData["DatenverwendungTelefon2Zustimmung"] && formData["TelefonGeschaeftlichVorwahl"] && formData["TelefonGeschaeftlichNummer"]) {
			formModel.Antragssteller.TelefonGeschaeftlichVorwahl = formData["TelefonGeschaeftlichVorwahl"];
			formModel.Antragssteller.TelefonGeschaeftlichNummer = formData["TelefonGeschaeftlichNummer"];
		}
	}

	public getAdvertisingConsentModel(userIp: string): AdvertisingConsentModel {
		const elements = this.options.$ctx.find(this.legalNotesSelector);
		const formData = AppUtils.Url.getParamsAsCSV(elements.serialize());

		const advertisingConsentModel = new AdvertisingConsentModel();
		advertisingConsentModel.UserIp = userIp;

		if (formData["Antragssteller.Datenverwendung.Einwilligung"]) {
			advertisingConsentModel.Einwilligung = Number(formData["Antragssteller.Datenverwendung.Einwilligung"]);
		}
		if (formData["DatenverwendungEmailZustimmung"]) {
			advertisingConsentModel.Email = Number(formData["DatenverwendungEmailZustimmung"]);
		}
		if (formData["DatenverwendungTelefonZustimmung"]) {
			advertisingConsentModel.Telefon = Number(formData["DatenverwendungTelefonZustimmung"]);

		}
		if (formData["DatenverwendungTelefon2Zustimmung"]) {
			advertisingConsentModel.Telefon2 = Number(formData["DatenverwendungTelefon2Zustimmung"]);

		}
		if (formData["ConsentInsurance"]) {
			advertisingConsentModel.InsuranceHint = Number(formData["ConsentInsurance"]) === 1;
		}

		if (formData["Personalisierung"]) {
			advertisingConsentModel.Personalisierung = formData["Personalisierung"] ? true : false;
		}

		return advertisingConsentModel;
	}

	public getMailText(): string {
		let jsMail = this.$ctx.find(".js-mail-text").val() as string;
		if (jsMail !== undefined && jsMail.includes(this.nameSelector) && jsMail.includes(this.surnameSelector) && jsMail.includes(this.titleSelector)) {
			jsMail = jsMail.replace(/{titel}/, this.$ctx.find("#hiddentitle").val().toString());
			jsMail = jsMail.replace(/{nachname}/, this.$ctx.find("#hiddenname").val().toString());
			jsMail = jsMail.replace(/{vorname}/, this.$ctx.find("#hiddenvorname").val().toString());
		}
		return jsMail;
	}

	public getHtmlMailText(): string {
		let jsMail = this.$ctx.find(".js-mail-html").val() as string;
		if (jsMail !== undefined && jsMail.includes(this.nameSelector) && jsMail.includes(this.surnameSelector) && jsMail.includes(this.titleSelector)) {
			jsMail = jsMail.replace(/{titel}/, this.$ctx.find("#hiddentitle").val().toString());
			jsMail = jsMail.replace(/{nachname}/, this.$ctx.find("#hiddenname").val().toString());
			jsMail = jsMail.replace(/{vorname}/, this.$ctx.find("#hiddenvorname").val().toString());
		}
		return jsMail;
	}

	public getSubject(): string {
		return this.$ctx.find(".js-mail-subject").val() as string;
	}
	public hideSepaNode(): void {
		this.$ctx.find(".js-sepa-node").toggleClass("h-hidden", true);
	}

	public getMailAttatchments(): string {
		return this.$ctx.find(".js-mail-attachments").val() as string;
	}

	public hasWalletBlock(): boolean {
		return this.$ctx.find(this.qrcodeSelector).length > 0;
	}

	public updateLegalValues(model: AppFormModel): void {
		const elements = this.$ctx.find(this.legalNotesSelector);
		const formData = AppUtils.Url.getParamsAsCSV(elements.serialize());
		model.BestimmungenAkzeptiert = !!formData.BestimmungenAkzepiert;
		model.WiederrufAkzeptiert = !!formData.WiederrufAkzeptiert;
	}

	public updateDigitalClubcardValues(model: AppFormModel): void {
		const elements = this.$ctx.find(this.digitalClubcardSelectior);
		if (elements.length > 0) {
			const formData = AppUtils.Url.getParamsAsCSV(elements.serialize());
			model.DigitaleClubkarte = formData.DigitaleClubkarte === "1";
		} else {
			model.DigitaleClubkarte = false;
		}
	}

	public hasSectionClubcard(): boolean {
		return this.$ctx.find(this.digitalClubcardSelectior).length !== 0;
	}

	public updateDiscountValues(model: AppFormModel): void {
		const elements = this.$ctx.find('form *[data-section="discount"]');
		const formData = AppUtils.Url.getParamsAsCSV(elements.serialize());
		model.IstSchwerbehindert = this.$ctx.find(this.isDisability).prop('checked');
		model.InAusbildung = this.$ctx.find(this.isEducation).prop('checked');
		model.Ausbildungsende = formData.Ausbildungsende;
		const behindertenausweis = new BehindertenausweisModel();
		behindertenausweis.Nummer = formData.Ausweisnummer;
		behindertenausweis.Grad = formData.Behinderungsgrad ? parseInt(formData.Behinderungsgrad) : null;
		model.Behindertenausweis = behindertenausweis;
	}

	public updateBonusValues(model: AppFormModel): void {
		model.Bonus.Bonuscode = this.$ctx.find(this.bonuscodeSelector).val() as string;
		model.Bonus.TextBonus = this.$ctx.find(".js-text-bonus").text();
		model.Bonus.EmailBonus = this.$ctx.find(".js-email-bonus").val() as string;
	}

	public replaceKooperationstoken(): void {
		const coop = this.$ctx.find(this.bonuscodeSelector).data("cooperationspartner");
		const errorMsg = this.$ctx.find('*[data-section="bonuscode"] .ll-error-msg').text();
		this.options.$ctx.find('*[data-section="bonuscode"] .ll-error-msg').text(errorMsg.replace("{kooperationspartner}", coop));
	}

	public updateChildSectionInformation(input: HTMLElement, child: ChildModel): void {
		const birthdayInput = this.$ctx.find(input);

		birthdayInput.closest(".js-clone").find(".js-child-label").toggleClass("h-hidden", child.IsJuv);
		birthdayInput.closest(".js-clone").find(".js-juv-label").toggleClass("h-hidden", !child.IsJuv);
	}

	public updateSalesmanFields(model: AppFormModel): void {
		if (this.options.app.issalesman && !this.options.app.salesmannumberfromurl) {
			model.Profiwerbernummer = this.$ctx.find(this.salesmanNoSelector).val() as string;
		}
	}

	public hideSalesmanFiels(): void {
		const jsCooperation = this.$ctx.find(this.cooperationSelector);
		if (jsCooperation) {
			jsCooperation.addClass("h-hidden");
		}
	}

	public getStartOfMembershipDate(): string {
		const currentStartDateField = this.$ctx.find(this.startOfMembershiFieldSelector);
		return currentStartDateField.length > 0 ? AppModelAdapter.getStartOfMembershipDate(currentStartDateField.val() as string) : "";
	}

	public getBisherigeMitgliedsnummer(): string {
		const field = this.$ctx.find("#BisherigeMitgliedsnummer");
		return field.val() !== undefined ? field.val() as string : undefined;
	}

	public getPersonalDataModel(): PersonalDataModel {
		const elements = this.$ctx.find('form *[data-section="personaldata"]');
		const formData = AppUtils.Url.getParamsAsCSV(elements.serialize());
		return this._getPersonalDataModel(formData);
	}

	public getPartnerDataModel(): PartnerViewModel {
		if (!this.$ctx.find("#addPartner").prop('checked')) {
			return undefined;
		}
		const elements = this.$ctx.find('form *[data-section="partnerdata"]');
		const formData = AppUtils.Url.getParamsAsCSV(elements.serialize());
		return this.getPartnerModel(formData);
	}

	public getChildDataModel(): Array<ChildModel> {
		const addChild = this.$ctx.find("#addChild").prop('checked');
		const addJuv = this.$ctx.find("#addJuv").prop('checked');
		if (!addChild && !addJuv) {
			return [];
		}
		const query = [];
		if (addChild) {
			query.push('form *[data-section="childdata"]');
		}
		if (addJuv) {
			query.push('form *[data-section="juvdata"]');
		}

		const elements = this.$ctx.find(query.join(", "));
		const formData = AppUtils.Url.getParamsAsCSV(elements.serialize());
		return this.getChildModelsV2(formData);
	}

	public getChildIdFromInputChangeEvent(e: Event): string {
		const split = $(e.currentTarget).attr("name").split("_");
		return `${split[1]}_${split[2]}`;
	}

	public getChildCount(): number {
		if (!this.$ctx.find("#addChild").prop('checked')) {
			return 0;
		}
		return this.$ctx.find('[name^="birth_child_"]:visible').filter(function () {
			return $(this).val() === "";
		}).length;
	}

	public getJuvCount(): number {
		if (!this.$ctx.find("#addJuv").prop('checked')) {
			return 0;
		}
		return this.$ctx.find('[name^="birth_adultchild_"]:visible').filter(function () {
			return $(this).val() === "";
		}).length;
	}

	public updateDiscountDebendentContent(): void {
		const inAusbildung = $(this.isEducation)[0] === undefined ? false : ($(this.isEducation)[0] as HTMLInputElement).checked;
		const istSchwerbehindert = $(this.isDisability)[0] === undefined ? false : ($(this.isDisability)[0] as HTMLInputElement).checked;
		if (this.appApplicationService.isYoungGenerationRate(this.options.app.rate.toString())) {
			$(this.discountSelector).hide(); //bei YG gibt's keine ermäßigten Tarife, NIE einblenden
		} else {
			if (istSchwerbehindert || inAusbildung) {
				$(this.discountSelector).show();
			} else {
				$(this.discountSelector).hide();
			}
		}
	}

	public hasAdacPayProductItem(): boolean {
		return this.$ctx.find(this.adacpaySelector).length > 0;
	}

	public updateRateDebendentContent(tarif: ContractInfoApi, rateoptions: Record<string, any>): void {
		const textJuvSelector = '.js-update-young-adults';
		const textJuvMoreSelector = '.js-update-young-adults-more';

		this.$ctx.find('.js-update-rate').text(tarif.Beitrag);
		this.$ctx.find('.js-update-rate-description').text(ContractInfo.getDescription(this.options.app.ratenamemappings, tarif.TarifCodeId));

		if (rateoptions) {
			if (0 < rateoptions.youngadultscount) {
				this.$ctx.find('#young_adults').show();
				this.$ctx.find(textJuvSelector).text(rateoptions.youngadultscount);
				if (2 < rateoptions.youngadultscount) {
					this.$ctx.find(textJuvSelector).hide();
					this.$ctx.find(textJuvMoreSelector).show();
				} else {
					this.$ctx.find(textJuvSelector).show();
					this.$ctx.find(textJuvMoreSelector).hide();
				}
			} else {
				this.$ctx.find('#young_adults').hide();
			}

			if (rateoptions.numberOfChildren > 0) {
				this.$ctx.find('#unlimited_children').show();
			} else {
				this.$ctx.find('#unlimited_children').hide();
			}

			if (rateoptions.hasPartner) {
				this.$ctx.find('#partner').show();
			} else {
				this.$ctx.find('#partner').hide();
			}
		}

	}

	public returnMainContentForApi(): string {
		const domain = location.origin; //set absolute url for image
		const $mainContent = this.getBaseMainContentForMail();

		$mainContent.find(".js-wallet-section").remove();
		$mainContent.find('img').remove();

		//add html
		const header = `<div><div><img src="${domain}/assets/img/logos/header-bestaetigungsmail.png" width="730" height="176" alt="ADAC" title="ADAC" /></div>`;
		const footer = "</div>";

		return header + $mainContent.html() + footer;
	}

	public returnMainContentForMember(): string {
		const domain = location.origin; //set absolute url for image
		const $mainContent = this.getBaseMainContentForMail();

		$mainContent.find(".js-wallet-section").remove();
		$mainContent.find('img').not(".js-keep-img").remove();
		$mainContent.find('img').not(this.qrcodeSelector).each((index, element) => {
			$(element).attr("src", domain + $(element).attr("src"));
		});

		//add html
		const header = `<div><div><img src="${domain}/assets/img/logos/header-bestaetigungsmail.png" width="730" height="176" alt="ADAC" title="ADAC" /></div>`;
		const footer = "</div>";

		return header + $mainContent.html() + footer;
	}

	private getBaseMainContentForMail(): JQuery {
		const $mainContent = $('#l_main_content').clone(true);

		$mainContent.find("script").remove();
		$mainContent.find("noscript").remove();
		$mainContent.find('input[type="hidden"]').remove();
		$mainContent.find('.js-print').remove();
		$mainContent.find('.js-sepa-node').remove();
		$mainContent.find('.js-register-form').remove();
		$mainContent.find('.js-check-copayment.h-hidden').remove();
		$mainContent.find(this.adacpaySelector).remove();
		$mainContent.find('.h-screen-only').remove();
		$mainContent.find('.h-hidden').remove();
		$mainContent.find('.m-basic-layer-survey').remove();
		$mainContent.find('#error_dialog').remove();

		return $mainContent;
	}

	public setQrCode(contentType: string, content: string): void {
		this.$ctx.find(this.qrcodeSelector).attr("src", `data:${contentType};base64,${content}`);
	}

	public setWalletAppUrl(url: string): void {
		this.$ctx.find(".js-appstore-url").attr("href", url);
	}

	public returnMailAttachments(): string {
		//PDF-IDs anhand Tarif aus hidden input holen
		return $('#MailAttachments').length > 0 ? ($('#MailAttachments')[0] as HTMLInputElement).value : '';
	}

	public enableBonusEmailField(): void {
		this.$ctx.find(".js-email-bonus").attr("disabled", null);
	}

	public addInputpageViewListeners(handler: InputPageViewEvents): void {
		const $inputPage = this.getForm();

		let firstMutation = true;
		const observer = new MutationObserver(() => {
			if (firstMutation) {
				firstMutation = false;
				handler.rerenderChildren();
			}
			handler.onViewChanged();
			handler.rateChangeListener();
			handler.onFamilyMemberAdded();
			this.updateInputpageListener(handler);
		});
		$inputPage.find(".js-child-clone-wrapper").each((index, element) => {
			observer.observe(element, {
				attributes: false,
				childList: true
			});
		});
		$inputPage.find(".js-clone-hidden").each((index, element) => {
			observer.observe(element, {
				attributes: true,
				attributeFilter: ["class"]
			});
		});
		$(window).on('pagehide', handler.pagehideListener ? handler.pagehideListener.bind(handler) : undefined);

		$inputPage.find("input").on("change", handler.onViewChanged.bind(handler));
		this.$ctx.find(this.submitBtnSelector).on("click", handler.onFormSubmit.bind(handler));
		$inputPage.on('submit', handler.onFormSubmit.bind(handler));
		$inputPage.find(this.rateDependSelector).on('change', handler.rateChangeListener.bind(handler));
		$inputPage.find('.js-birthday-legal-update').on('change', handler.onBirthdateChange.bind(handler));
		$inputPage.find(this.salesmanNoSelector).on('blur', handler.salesmanNoBlurListener.bind(handler));
		$inputPage.find(this.bonuscodeSelector).on('change', handler.validateBonuscode.bind(handler));
		$inputPage.find(this.bonuscodeSelector).on('blur', handler.validateBonuscode.bind(handler));
		$inputPage.find(this.birthdayChildSelector).on('change', handler.onChildBirthdayChanged.bind(handler));

		$inputPage.find('#email, #TelefonVorwahl, #TelefonNummer, #TelefonGeschaeftlichVorwahl, #TelefonGeschaeftlichNummer').on('focus', this.showContractHint.bind(this, true));
		$inputPage.find('#email, #TelefonVorwahl, #TelefonNummer, #TelefonGeschaeftlichVorwahl, #TelefonGeschaeftlichNummer').on('focusout', this.showContractHint.bind(this, false));

		const $autocomplete = $inputPage.find('[data-t-decorator="autocomplete"]');
		if ($autocomplete) {
			this.$ctx.on('automcompleteSelect', this.handleAddressAutocompleteSelection.bind(this, false));
			$autocomplete.on('keypress', (e) => {
				if (e.key === 'Enter' && $autocomplete.data(this.autocompletePendingFlag)) {
					$autocomplete.data(this.autocompletePendingFlag, null);
				}
			});
			$autocomplete.trigger('keypress');
		}
		T.Utils.Helper.appendDeviceUrlParamToAllLinksInContext(this.$ctx);
		S.Utils.Lightbox.init();
	}

	public updateInputpageListener(handler: InputPageViewEvents): void {
		const $inputPage = this.getForm();
		const $familySection = $inputPage.find(".js-additional-family");
		$familySection.find("input").off("change");
		$familySection.find(this.birthdayChildSelector).off('change');
		$familySection.find(this.rateDependSelector).off('change');
		$familySection.find("input").on("change", handler.onViewChanged.bind(handler));
		$familySection.find(this.rateDependSelector).on('change', handler.rateChangeListener.bind(handler));
		$familySection.find(this.birthdayChildSelector).on('change', handler.onChildBirthdayChanged.bind(handler));
		$familySection.find('[name="vollmacht"]').on('change', (e) => {
			$familySection.find('[name="vollmacht"]').prop("checked", $(e.currentTarget).prop("checked"));
		});
	}

	public showErrorDialog(msg: string, closeCallback: JQuery.EventHandler<HTMLElement>): void {
		const $dialog = $("#freundewerben-check");
		if (msg) {
			$dialog.find('.error-msg').html(msg);
		}

		this.openDialog($dialog, closeCallback);
	}

	public showStreetErrorDialog(): void {
		const $dialog = $("#street-no-err");
		this.openDialog($dialog, () => {
			//NOSONAR
		});
	}

	public setConfigAutocompleteAddress(): void {
		const $autocomplete = this.getForm().find('input.js-autocomplete-address');
		const searchUrl = this.urlBuilder.fullApimUrl(this.options.app.apiautocompleteaddress);
		$autocomplete.attr('data-subscription-key', T.Utils.Application.apimSubscriptionKey);
		$autocomplete.attr('data-searchurl', searchUrl);
	}

	private openDialog(dialog: JQuery, closeCallback: JQuery.EventHandler<HTMLElement>): void {
		$.magnificPopup.open({
			items: {
				src: dialog
			},
			fixedContentPos: true,
			modal: true,
			callbacks: {
				beforeOpen: function () {
					// setup classes
					dialog.addClass("ll-lightbox-inner");
					this.st.mainClass = "mfp-zoom-in l-lightbox";
				},
				close: closeCallback.bind(this)
			}
		});
	}

	private showContractHint(val: boolean): void {
		const $inputPage = this.getForm();
		$inputPage.find(".js-contract-hint div:first-child").toggleClass('js-focus', val);
	}

	public addCheckListeners(
		onViewChanged: JQuery.EventHandler<HTMLElement>,
		backLinkListener: JQuery.EventHandler<HTMLElement>,
		submitEnclosure: JQuery.EventHandler<HTMLElement>,
		captchaHandler: JQuery.EventHandler<HTMLElement>): void {
		const $form = this.getHtml();

		$form.find("input").on("change", onViewChanged);
		$form.find(this.backlinkSelector).on('click', backLinkListener);
		$form.find(this.submitBtnSelector).on('click', submitEnclosure);
		$form.on('captcha-completed', captchaHandler);
		$form.find(this.emailPhoneAndPersonalizationSelector).on('change', this.toggleIpHint.bind(this));
		$form.find(this.emailPhoneAndPersonalizationSelector).on('change', this.toggleEinwilligung.bind(this));
		$form.find('input').on('change', this.permissionChangedListener.bind(this));

		$form.find('.js-phone').on('change', this.showPhoneHint.bind(this));
		$form.find(this.einwilligungSelector).on('change', this.clearOptions.bind(this));

		this.permissionChangedListener();
		T.Utils.Helper.appendDeviceUrlParamToAllLinksInContext(this.$ctx);
		S.Utils.Form.init();
		S.Lazy.init();
	}

	private clearOptions(): void {
		const $page = this.getForm();
		const einw = $page.find(this.einwilligungSelector);
		if (!einw.is("checked")) {
			this.$ctx.find(this.emailPhoneAndPersonalizationSelector).prop("checked", false);
			this.showPhoneHint();
			this.toggleIpHint();
		}
	}

	private showPhoneHint(): void {
		const $page = this.getForm();
		$page.find(".js-phone-hint").toggleClass('js-focus', $page.find(".js-phone").is(":checked"));
	}

	private permissionChangedListener(): void {
		const $form = this.$ctx.find(`#${this.formId}`);
		$form.find('input[type="checkbox"]').each((index, element: HTMLInputElement) => {
			const $elem = $(element);
			if ($elem.is(":checked")) {
				$elem.parent().find('input[type="text"]').attr("required", "required");
			} else {
				$elem.parent().find('input[type="text"]').removeAttr("required");
			}
		});
	}

	public toggleSubmitButton(toggle: boolean): void {
		const $form = this.$ctx.find(`#${this.formId}`);
		$form.find(this.submitBtnSelector).prop('disabled', toggle);
		$form.find(this.submitBtnSelector).toggleClass('is-disabled', toggle);
	}

	private toggleIpHint(): void {
		const $form = this.getHtml();
		$form.find(".js-ip-hint").toggleClass("h-hidden", !$form.find(this.emailPhoneAndPersonalizationSelector).is(":checked"));
	}

	private toggleEinwilligung(): void {
		const $form = this.getHtml();
		if (!$form.find(this.emailPhoneAndPersonalizationSelector).is(":checked")) {
			$form.find(this.einwilligungSelector).trigger("click");
		}
	}

	public addConfirmationPageListener(onAdacPayItemClicked: JQuery.EventHandler<HTMLElement>): void {
		this.$ctx.find(".js-adac-pay .js-adacpay-submit").on("click", onAdacPayItemClicked);
		S.Globals.lazyloadertx.init();
	}

	public getGeburtsdatumAntragsteller(): string {
		return $("*[name='Geburtsdatum']").val() as string;
	}

	public getGeburtsdatumPartner(): string {
		return $("*[name='GeburtsdatumPartner']").val() as string;
	}

	public getKinderGeburtstage(): Array<string> {
		const kinderGeburtsdatumArray = new Array<string>();
		this.$ctx.find(this.birthdayChildSelector).each((index, element) => {
			if ($(element).val()) {
				kinderGeburtsdatumArray.push(this.timeService.formatDate($(element).val() as string));
			}
		});

		return kinderGeburtsdatumArray;
	}

	public checkCoPayment(friendsAdvertisingData: MglPartnerAdvertising): void {
		if (friendsAdvertisingData.productActiveCopayment) {
			this.$ctx.find('.js-check-copayment').removeClass('h-hidden');
		}
	}

	public getSepaAnchor(): JQuery {
		return this.$ctx.find('a.sepa');
	}

	private getHtml(): JQuery {
		return this.$ctx.find(`#${this.formId}`);
	}

	public setLogoutReturnUrl(newUrl: string): void {
		$('body #logout').attr('action',
			AppUtils.Url.updateUrlParameter({ 'returnUrl': newUrl }, $('body #logout').attr('action'))
		);
	}

	get DateofbirthSelector(): string {
		return this.dateofbirthSelector;
	}

	/**
	 * Get Werbetext from View to send to EMAIL API
	 */
	public getAdverstingTextFromView(): string {
		return this.$ctx.find('.js-Werbetext').text() ?? "";
	}

	/**
	 * Get form for ADAC Pay
	 */
	public getAdacPayForm(): JQuery {
		return $(this.options.$ctx).find('form[ name="adacpay-form"]');
	}
	/**
	 * Get Predate from View
	 */
	public GetPreDate(): string {
		return this.$ctx.find(this.startOfMembershiFieldSelector).attr('data-predate');
	}

	public updateOfficeAdvertisingKey(model: AppFormModel): void {
		if (this.options.app.isofficeadvertisingkey && model.Werbeschluessel === undefined) {
			model.OfficeWerbeschluessel = this.$ctx.find(this.officeAdvertisingKey).val() as number;
			this.$ctx.find(this.officeAdvertisingKey).removeAttr("data-alreadyvalidated");
		}
	}

	public showCommercialNotice(): void {
		this.$ctx.find('.js-agecheck').toggleClass('h-hidden', false);
	}

	public getAdvertisingConsentConfig(): { version: string, trackingVersion: string, companyIdentifier: string, companyIdentifierReferenceCode: string, trackingReferenceId: string } {
		const advertisingConsentVersion = this.$ctx.find('.js-advertisingconsentversion');
		if (advertisingConsentVersion && advertisingConsentVersion.length > 0) {
			return advertisingConsentVersion.data("config");
		}
		return {
			version: '', trackingVersion: '', companyIdentifier: '', companyIdentifierReferenceCode: '', trackingReferenceId: ''
		};
	}

	public mapDataToSolarisForm(data: any, action: string): void {
		const form = this.$ctx.find("#routetargetform");
		if (form && form.length > 0) {
			const tokenInput = form.find('#token');
			if (tokenInput && tokenInput.length > 0) {
				form.attr('target', '_blank');
				form.prop('action', action);
				form.prop('method', "get");
				tokenInput.val(data.Token);
			}
		}
	}

	public setRedirectLinkUrl(token: string): void {
		this.$ctx.find('.js-link-target-bank').attr('href', `${this.options.app.creditcardweburl}?${token}`);
	}

	public registerBankAccountFormSubmitListener(onTriggerTargetBank: JQuery.EventHandler<HTMLElement>): void {
		this.$ctx.find('.js-link-target-bank').on('click', onTriggerTargetBank.bind(this));
	}

	public triggerTargetBankFormSubmit(): void {
		this.$ctx.find('#routetargetform').trigger("submit");
	}
}

